module.exports = __webpack_public_path__ + "static/media/ASSET_MOBILE_CHAT.73c63fdf.png";